module.exports = __webpack_public_path__ + "static/yachtsafe-extraimg2@2x-min-38f9b773b53c08103506a1fc64b529f0.png";